// Текст ошибки из ответа API. Перехватчик в api.service.ts возвращает ответ с ошибкой как обычный,
// а при сетевой ошибке undefined. Бэкенд кладет текст то в message, то строкой в errors
export function apiErrorMessage(res: any, fallback = 'Не удалось сохранить, попробуйте еще раз'): string {
  const data = res && res.data
  if (data && typeof data.message === 'string' && data.message) {
    return data.message
  }
  if (data && typeof data.errors === 'string' && data.errors) {
    return data.errors
  }
  return fallback
}
